import React from 'react';
import ITService from '../images/it.svg';
import { Link } from 'react-router-dom';
import { FaCloud, FaLock, FaMobileAlt, FaDesktop } from 'react-icons/fa';
import SubserviceDetailComponent from '../components/SubserviceDetailComponent';

const services = [
  {
    icon: <FaCloud />,
    title: 'Hardware Management',
    description: 'Optimize your hardware with our management services. We handle installation, maintenance, and upgrades to ensure reliable performance.',
  },
  {
    icon: <FaLock />,
    title: 'Cloud Infrastructure Management',
    description: 'Manage your cloud resources effectively with our services. We oversee cloud environments to ensure scalability, security, and cost-efficiency.',
  },
  {
    icon: <FaMobileAlt />,
    title: 'Server and Storage Solutions',
    description: 'Implement robust server and storage solutions to support your business needs. We provide reliable and scalable options for data management.',
  },

  {
    icon: <FaMobileAlt />,
    title: 'Disaster Recovery Planning',
    description: 'Prepare for the unexpected with comprehensive disaster recovery planning. We develop strategies to ensure data protection and business continuity.',
  },
];

const ITInfrastructure = () => {
  return (
    <div className = "relative">
      <img
        className="h-auto w-full object-cover"
        src={ITService}
        alt="IT Services"
      />

      <div>

      <section className='text-left mt-6'>
      <h1 className="text-center my-6 text-2xl font-semibold">IT Infrastructure Management</h1>
      </section>
     

      <section>
        <SubserviceDetailComponent services={services}/>
        <div className='mb-6'>
      <h2 className="text-xl font-semibold mb-6 mx-6">Get Started with Expert IT Services</h2>
      <p className="text-md text-black mb-6 px-12 text-left">
      Maximize efficiency, enhance security, and drive growth with our tailored IT Services. Our certified experts provide 24/7 support, proactive monitoring, and strategic IT planning to meet your business needs.
      </p>
      
      <Link to="/contact"
        className="inline-block bg-[#13689b] text-white py-3 px-6 rounded-md text-md font-semibold transition-transform transform hover:scale-105">
      Contact Us
      </Link>
      </div>
      </section>

    </div>

    </div>
  )
}

export default ITInfrastructure
